import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import Navbar from "../Navbar";
import forest from "../../assets/images/forest.png";
import aiCompanion from "../../assets/images/ai-companion.png";
import "./SpaceSelection.css";
import Footer from "../Footer";
import { isMobile, isTablet } from "react-device-detect";

function SpaceSelection() {
  const navigate = useNavigate();
  const { 
    setSelectedTherapyType, 
    userType, 
    verifiedUserAccess, 
    accessVerificationComplete,
    verifyUserAccessFromServer 
  } = useContext(AuthContext);

  useEffect(() => {
    if (userType === "Therapist") {
      navigate("/clients");
      return;
    }
  }, [userType, navigate]);

  useEffect(() => {
    if (userType && !accessVerificationComplete && userType !== "Therapist") {
      verifyUserAccessFromServer();
    }
  }, [userType, accessVerificationComplete, verifyUserAccessFromServer]);

  const getFallbackAccess = (userType) => {
    switch (userType) {
      case "client-ai-enabled-therapy":
        return { canAccessAI: true, canAccessTherapy: true, isTherapist: false };
      case "client-ai-companion":
        return { canAccessAI: true, canAccessTherapy: false, isTherapist: false };
      case "Client":
        return { canAccessAI: false, canAccessTherapy: true, isTherapist: false };
      case "Therapist":
        return { canAccessAI: true, canAccessTherapy: true, isTherapist: true };
      default:
        return { canAccessAI: false, canAccessTherapy: false, isTherapist: false };
    }
  };

const isPhone = isMobile && !isTablet;

  let userAccess = null;

if (
  accessVerificationComplete &&
  verifiedUserAccess
) {
  userAccess = verifiedUserAccess;
} else if (userType) {
  // fallback while verifying
  userAccess = getFallbackAccess(userType);
}
  
  const handleHumanTherapySelect = () => {
    if (!userAccess.canAccessTherapy) {
      console.error("SpaceSelection.js: error event");
      alert(`You don't have access to therapy rooms. Your user type: ${userType}. Please contact support.`);
      return;
    }
    setSelectedTherapyType("human");
    window.location.assign("https://mobiledev.plutonichealth.co/");
  };

  const handleAITherapySelect = () => {
    if (!userAccess.canAccessAI) {
      console.error("SpaceSelection.js: error event");
      alert(`You don't have access to AI companion rooms. Your user type: ${userType}. Please upgrade your subscription.`);
      return;
    }
    setSelectedTherapyType("ai");
    navigate("/aimh");
  };

  if (!userAccess) {
    return (
      <>
        <Navbar />
        <div className="space-selection-container" style={{ paddingTop: "120px" }}>
          <div className="flex items-center justify-center h-[60vh] text-white text-xl">
            Loading...
          </div>
        </div>
        <Footer />
      </>
    );
  }

  if (isPhone) {
  return (
    <>
      <Navbar />
      <div className="space-selection-container" style={{ paddingTop: "120px" }}>
        <div className="flex items-center justify-center h-[60vh] text-white text-xl text-center px-4">
          Plutonic is not supported on mobile devices at this time. Please login on your computer to use your AI companion.
        </div>
      </div>
      <Footer />
    </>
  );
}

  return (
    <>
      <Navbar />
      <div
        className="space-selection-container"
        style={{ paddingTop: "120px" }}
      >
        <div className="space-selection-header">
          <h1 className="space-selection-title">Choose Your Path</h1>
        </div>

        <div className="space-selection-content">
          <div className="space-cards-container">
             {userAccess.canAccessTherapy && (
  <div
    className="space-card human-therapy-card"
    style={{
      background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.7)), url(${forest}) center/cover`,
    }}
  >
    <div className="card-image-section">
      <div className="card-overlay">
        <h2 className="card-title">Enter Into Your Therapy Session</h2>
        <p className="card-subtitle">Talk to Your Therapist</p>
        <div className="card-accessibility">
          <p>Current Accessibility | PC Web Browser</p>
          <p>Chrome, Edge</p>
        </div>
      </div>
    </div>

    <button
      disabled={!userAccess.canAccessTherapy}
      className="select-space-btn"
      onClick={handleHumanTherapySelect}
    >
      {userAccess.canAccessTherapy ? "Select Space" : "Upgrade Required"}
    </button>
  </div>
)}

             <div
               className={`space-card ai-therapy-card ${!userAccess.canAccessAI ? 'disabled-card' : ''}`}
               style={{
                 background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.7)), url(${aiCompanion}) center/cover`,
               }}
             >
              <div className="card-image-section">
                <div className="card-overlay">
                  <h2 className="card-title">Talk to Your Mental Health Companion</h2>
                  <div className="card-accessibility">
                    <p >Current Accessibility | PC Web Browser</p>
                    <p>Chrome, Edge</p>
                  </div>
                </div>
              </div>
              <button
                disabled={!userAccess.canAccessAI}
                className="select-space-btn"
                onClick={handleAITherapySelect}
              >
                {userAccess.canAccessAI ? 'Select Space' : 'Upgrade Required'}
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default SpaceSelection;
